var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertWarning = function SvgAlertWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Alert_Warning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm4.46 11.63-.83.83L10 10.83l-3.63 3.63-.83-.83L9.17 10 5.54 6.37l.83-.83L10 9.17l3.63-3.63.83.83L10.83 10l3.63 3.63Z",
    fill: "#E53935"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Alert_Warning_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgAlertWarning;